var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 210,
    viewBox: "0 0 252 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_3330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 248,
    height: 206,
    rx: 19.9286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.969 104.38C169.969 124.567 153.594 140.932 133.394 140.932C113.193 140.932 96.8179 124.567 96.8179 104.38C96.8179 84.1936 113.193 67.8281 133.394 67.8281C153.594 67.8281 169.969 84.1936 169.969 104.38Z",
    fill: "#E72445",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.394 89.3604V104.381",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.394 119.401H133.437",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.456 97.9434C108.456 104.016 103.53 108.941 97.4515 108.941C91.3732 108.941 86.4468 104.016 86.4468 97.9434C86.4468 91.8705 91.3732 86.9463 97.4515 86.9463C103.53 86.9463 108.456 91.8705 108.456 97.9434Z",
    fill: "white",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8574 136.841C73.8574 123.81 84.4213 113.246 97.4525 113.246C110.484 113.246 121.048 123.81 121.048 136.841V140.178H73.8574V136.841Z",
    fill: "white",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.104,
    y: 159.42,
    width: 35.4286,
    height: 35.4286,
    rx: 17.7143,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.461 170.491L44.1753 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1752 170.491L57.4609 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8179,
    y: 159.42,
    width: 35.4286,
    height: 35.4286,
    rx: 17.7143,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.175 170.491L92.8896 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8896 170.491L106.175 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.532,
    y: 159.42,
    width: 35.4286,
    height: 35.4286,
    rx: 17.7143,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89 170.491L141.604 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.604 170.491L154.89 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.247,
    y: 159.42,
    width: 35.4286,
    height: 35.4286,
    rx: 17.7143,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.604 170.491L190.318 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.318 170.491L203.604 183.777",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 22.9778C2 10.7487 11.9137 0.834961 24.1429 0.834961H227.857C240.086 0.834961 250 10.7487 250 22.9778V47.0617H2V22.9778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 47.0615H250",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8045 25.916C27.8045 28.9185 25.3688 31.3535 22.3629 31.3535C19.3571 31.3535 16.9214 28.9185 16.9214 25.916C16.9214 22.9136 19.3571 20.4785 22.3629 20.4785C25.3688 20.4785 27.8045 22.9136 27.8045 25.916Z",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1287 25.916C47.1287 28.9185 44.693 31.3535 41.6872 31.3535C38.6813 31.3535 36.2456 28.9185 36.2456 25.916C36.2456 22.9136 38.6813 20.4785 41.6872 20.4785C44.693 20.4785 47.1287 22.9136 47.1287 25.916Z",
    stroke: "#070C1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4539 25.916C66.4539 28.9185 64.0182 31.3535 61.0124 31.3535C58.0065 31.3535 55.5708 28.9185 55.5708 25.916C55.5708 22.9136 58.0065 20.4785 61.0124 20.4785C64.0182 20.4785 66.4539 22.9136 66.4539 25.916Z",
    stroke: "#070C1A",
    strokeWidth: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 250,
    height: 208,
    rx: 20.9286,
    stroke: "#070C1A",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_3330"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 248,
    height: 206,
    rx: 19.9286,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnAuth);
export default __webpack_public_path__ + "static/media/unAuth.0bb79c7e220f25b13e559122231c3952.svg";
export { ForwardRef as ReactComponent };